<script setup>
/**
 * RM-360 — the member's request preview link, opened inside the app: the same
 * page a text or email carries (/referral/preview/<code>), which switches
 * between the request's restaurants and between each one's response page,
 * email and text itself.
 */
defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  // '/referral/preview/<code>' (POST /reservation/:id/preview-link)
  path: {
    type: [String, null],
    default: null,
  },
})

const emit = defineEmits(['update:modelValue'])

const close = () => emit('update:modelValue', false)
</script>

<template>
  <VDialog
    :model-value="modelValue"
    fullscreen
    @update:model-value="value => emit('update:modelValue', value)"
  >
    <VCard class="request-preview-dialog">
      <iframe
        v-if="path"
        :src="path"
        title="What the restaurant receives"
        class="request-preview-dialog__frame"
      />
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      aria-label="Close preview"
      @click="close"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>
</template>

<style lang="scss" scoped>
.request-preview-dialog {
  display: flex;
  block-size: 100%;
}

.request-preview-dialog__frame {
  flex: 1;
  border: 0;
  inline-size: 100%;
}

.dialog-close-btn {
  position: fixed;
  inset-block-start: 6px;
  inset-inline-end: 6px;
}
</style>
